import { render, staticRenderFns } from "./GroupingView.vue?vue&type=template&id=7831e052&scoped=true"
import script from "./GroupingView.vue?vue&type=script&lang=js"
export * from "./GroupingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831e052",
  null
  
)

export default component.exports